import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

const LIKERT_CHOICE_STYLES = ['multiple', 'single']

export default function likertChoiceStyleBuilder({
  rawField,
}: FieldBuilderParams): Partial<BuiltFieldAttributes> | undefined {
  if (!rawField.likertChoiceStyle || !LIKERT_CHOICE_STYLES.includes(rawField.likertChoiceStyle)) return

  return {
    likertChoiceStyle: rawField.likertChoiceStyle,
  }
}
